import type { SubscriptionPublic } from '@hero/schema';

/**
 * Whether `/billing/plan` should bounce the user back to `/billing`.
 *
 * The plan picker is for first-time checkout, trial conversion,
 * re-subscribe after cancel, and overdue recovery — not for managing
 * a healthy paid subscription. Upgrades / add-seats will re-open this
 * route later behind explicit CTAs.
 *
 * Redirect targets:
 *   - `active` — live paid subscription (the common "I typed /billing/plan"
 *     case while already subscribed).
 *   - `paused` — admin-paused; manage from the overview.
 *
 * Still allowed on `/billing/plan`:
 *   - no subscription (`null`)
 *   - `trialing` — pick a plan + pay to convert
 *   - `canceled` — re-subscribe CTA from overview
 *   - `past_due` — paywall "Resubscribe" and grace-period recovery
 */
export function shouldRedirectFromBillingPlanPicker(
  subscription: SubscriptionPublic | null,
): boolean {
  if (!subscription) return false;

  return subscription.status === 'active' || subscription.status === 'paused';
}
